var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap',{attrs:{"containerHeight":"100%","height":"100%","center":_vm.mapCenter,"addMarkerToCenter":_vm.addMarkerToCenter,"markerOptions":{
    optimized: false,
  },"markerIconOptions":_vm.currentLocationMarkerIcon,"zoom":16},on:{"mapReady":_vm.handleMapReady}})}
var staticRenderFns = []

export { render, staticRenderFns }